import { Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TreeNode } from 'src/app/models/tree-node';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ModalAddFloorComponent } from '../modals/modal-add-floor.component';

@Component({
  selector: 'app-tree-view',
  template: `
    <ul class="tree-list ms-0">
      <li *ngFor="let node of nodes" class="tree-node">
        <div class="tree-node-label" [ngClass]="node.type==2 ? 'my-2 bg-light py-2 px-1 rounded-2' : node.type==1 ? 'bg-secondary text-light py-2 rounded-2 px-2' : node.type==0 ? 'bg-white py-2 rounded-2 px-2' : ''">
          <div class="d-flex">
            <div>
              <span
                *ngIf="node.children?.length"
                (click)="toggleExpand(node)"
                class="toggle-icon"
              >
                <fa-icon *ngIf="!node.isExpanded" [icon]="icons.faChevronRight"></fa-icon>
                <fa-icon *ngIf="node.isExpanded" [icon]="icons.faChevronDown"></fa-icon>
              </span>
              <span class="ms-2 pt-1" [ngStyle]="{ 'fontWeight': 'bold'}">{{node.name}}</span>
            </div>
            <div class="ms-auto" *ngIf="node?.type===2">
              <button class="btn btn-sm btn-default p-0 text-dark ms-2 me-1" routerLink="/condominios/{{node?.settlement_id}}/unidad/{{node.id}}">
                <fa-icon [icon]="icons.faEdit" class="text-end"></fa-icon>
              </button>
            </div> 
            <div class="ms-auto" *ngIf="node?.type===1">
              <button class="btn btn-sm btn-default p-0 text-light ms-2" (click)="editFloor(node.id)">
                <fa-icon [icon]="icons.faEdit" class="text-end"></fa-icon>
              </button>
              <button class="btn btn-sm btn-default p-0 text-light ms-2" (click)="addUnit(node.id)">
                <fa-icon [icon]="icons.faPlus" class="text-end"></fa-icon>
              </button>
            </div>
            <div class="ms-auto" *ngIf="node?.type===0">
              <button class="btn btn-sm btn-default p-0 text-dark ms-2" (click)="updateBuilding(node.id)">
                <fa-icon [icon]="icons.faEdit" class="text-end"></fa-icon>
              </button>
              <button class="btn btn-sm btn-default p-0 text-dark ms-2" (click)="addFloor(node.id)">
                <fa-icon [icon]="icons.faPlus" class="text-end"></fa-icon> Piso
              </button>
            </div>
          </div>
          <div class="list-group w-100 mt-2 ms-2" *ngIf="node.tanques?.length>0">
            <div class="list-group-item" *ngFor="let tanque of node.tanques">
              <div class="d-flex">
                <div><ngx-emoji emoji="alembic" style="width: 10px !important; height: 10px !important;"></ngx-emoji></div>
                <div class="ms-2 mt-1">
                  <strong>{{ tanque.name }}</strong>
                </div>
                <div class="ms-auto mt-1">
                  Capacidad: {{tanque.capacidad}} {{tanque.unidad}}
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm w-100 mt-1" *ngIf="node.type===2" style="font-size: 0.8em;">
            <tr>
              <td *ngIf="node.status === 0 || node.status === 1">
                <span *ngIf="node.status === 1" class="bg-transparent">
                  <fa-icon [icon]="icons.faCircleCheck" class="text-success"></fa-icon>
                  Activo
                </span>
                <span *ngIf="node.status === 0" class="bg-transparent">
                  <fa-icon [icon]="icons.faCircleExclamation" class="text-warning"></fa-icon>
                  Inactivo
                </span>
              </td>
              <td *ngIf="node.gas_meters?.length>0">
                <span *ngIf="node.gas_meters[0].meter_code">
                  <fa-icon [icon]="icons.faCircleCheck" class="text-success"></fa-icon>
                </span>
                <span *ngIf="!node.gas_meters[0].meter_code">
                  <fa-icon [icon]="icons.faCircleExclamation" class="text-warning"></fa-icon>
                </span>
                Medidor de gas ({{node.gas_meters.length}})
              </td>
              <td *ngIf="node.gas_meters?.length==0" class="bg-transparent">
                <fa-icon [icon]="icons.faCircleExclamation" class="text-danger bg-transparent"></fa-icon>
                Medidor de gas ({{node.gas_meters.length}})
              </td>
            </tr>
            <tr>
              <td *ngIf="node.tenants?.length>0">
                <fa-icon [icon]="icons.faCircleCheck" class="text-success"></fa-icon>
                Inqulinos ({{node.tenants.length}})
              </td>
              <td *ngIf="node.tenants?.length===0">
                <fa-icon [icon]="icons.faCircleExclamation" class="text-warning"></fa-icon>
                Inqulinos ({{node.tenants.length}})
              </td>

              <td  *ngIf="node.subscriptions?.length>0">
                <fa-icon [icon]="icons.faCircleCheck" class="text-success"></fa-icon>
                Suscripción
              </td>
              <td  *ngIf="node.subscriptions?.length===0">
                <fa-icon [icon]="icons.faCircleExclamation" class="text-danger"></fa-icon>
                Suscripción
              </td>
            </tr>
          </table>
        </div>
        <!-- Render children recursively -->
        <app-tree-view
          *ngIf="node.isExpanded && node.children?.length"
          [nodes]="node.children || []"
          [settlementId]="settlementId"
          [isChildComponent]="true"
          (floorEdit)="onChildFloorEdit($event)"
          (addUnitData)="onChildAddUnitData($event)"
          (floorData)="onChildFloorData($event)"
          (updateBuildingData)="onChildUpdateBuildingData($event)"
          (updateDismiss)="onChildUpdateDismiss()"
        ></app-tree-view>
      </li>
    </ul>
    <app-modal-add-floor [building]="selectedBuilding" (updateDismiss)="updateDismissed()"></app-modal-add-floor>
  `,
  styleUrls: []
})
export class TreeViewComponent implements OnInit, OnChanges {
  @Input() settlementId: any;
  @Input() nodes: TreeNode[] = [];
  @Input() isChildComponent: boolean = false; // Flag to identify if this is a nested instance
  @ViewChild(ModalAddFloorComponent, { static: true }) modalAddFloorComponent !: ModalAddFloorComponent;
  @Output() floorEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() addUnitData: EventEmitter<any> = new EventEmitter<any>();
  @Output() floorData: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateBuildingData: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();

  selectedBuilding: any = null;

  toggleExpand(node: TreeNode): void {
    node.isExpanded = !node.isExpanded;
  }

  constructor(
    public icons: IconsService,
    private ngZone: NgZone
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    // Log when inputs change to help debug
    if (changes['nodes']) {
      // console.log('TreeViewComponent: nodes input changed, new value count:', this.nodes?.length);
    }
    if (changes['settlementId']) {
      // console.log('TreeViewComponent: settlementId changed to:', this.settlementId);
    }
  }

  ngOnInit(): void {
  }

  editFloor(floor_id: any) {
    try {
      // Use the actual floor_id, not a hardcoded value
      this.ngZone.run(() => {
        this.floorEdit.emit(floor_id);
      });
    } catch (error) {
      console.error(`${this.isChildComponent ? 'CHILD' : 'ROOT'} TreeViewComponent: Error in editFloor while emitting event:`, error);
    }
  }

  addUnit(floor_id: any) {
    if (!floor_id) {
      console.error(`${this.isChildComponent ? 'CHILD' : 'ROOT'} TreeViewComponent: addUnit - floor_id is required`);
      return;
    }
    
    try {
      this.ngZone.run(() => {
        this.addUnitData.emit(floor_id);
      });
    } catch (error) {
      console.error(`${this.isChildComponent ? 'CHILD' : 'ROOT'} TreeViewComponent: Error in addUnit while emitting event:`, error);
    }
  }

  addFloor(building_id: any) {
    if (!building_id) {
      console.error(`${this.isChildComponent ? 'CHILD' : 'ROOT'} TreeViewComponent: addFloor - building_id is required`);
      return;
    }
    
    try {
      this.ngZone.run(() => {
        this.floorData.emit(building_id);
      });
    } catch (error) {
      console.error(`${this.isChildComponent ? 'CHILD' : 'ROOT'} TreeViewComponent: Error in addFloor while emitting event:`, error);
    }

    this.selectedBuilding = building_id;
    const modalTemplate: any | undefined = this.modalAddFloorComponent;
    if (modalTemplate) {
      modalTemplate.initForm();
      modalTemplate.openModal(modalTemplate['modalAddFloor']);
    } else {
      console.error(`${this.isChildComponent ? 'CHILD' : 'ROOT'} TreeViewComponent: modalAddFloorComponent is undefined`);
    }
  }

  updateDismissed() {
    try {
      this.ngZone.run(() => {
        this.updateDismiss.emit();
      });
    } catch (error) {
      console.error(`${this.isChildComponent ? 'CHILD' : 'ROOT'} TreeViewComponent: Error in updateDismissed while emitting event:`, error);
    }
  }

  updateBuilding(building_id: any) {
    try {
      this.ngZone.run(() => {
        this.updateBuildingData.emit(building_id);
      });
    } catch (error) {
      console.error(`${this.isChildComponent ? 'CHILD' : 'ROOT'} TreeViewComponent: Error in updateBuilding while emitting event:`, error);
    }
  }

  // Event handlers for bubbling up events from child tree-view components
  onChildFloorEdit(event: any) {
    this.floorEdit.emit(event);
  }

  onChildAddUnitData(event: any) {
    this.addUnitData.emit(event);
  }

  onChildFloorData(event: any) {
    this.floorData.emit(event);
  }

  onChildUpdateBuildingData(event: any) {
    this.updateBuildingData.emit(event);
  }

  onChildUpdateDismiss() {
    this.updateDismiss.emit();
  }

}
